// extracted by mini-css-extract-plugin
export default {"root":"_3Zzs5","small":"_223NH","normal":"_3x1Nw"};